import {
  GET_CURRENT_USER,
  GET_OTP,
  GET_OTP_ERROR,
  GET_OTP_LOADING,
  GET_OTP_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_ERROR,
  LOGOUT_USER_SUCCESS,
  VERIFY_OTP,
  VERIFY_OTP_ERROR,
  VERIFY_OTP_LOADING,
  VERIFY_OTP_SUCCESS,
  VERIFY_USER,
  VERIFY_USER_ERROR,
  VERIFY_USER_SUCCESS,
} from "./constant";

// get OTP actions
export const getOTP = (payload) => ({ type: GET_OTP, payload });
export const getOTPLoading = () => ({ type: GET_OTP_LOADING });
export const getOTPSuccess = (payload) => ({
  type: GET_OTP_SUCCESS,
  payload,
});
export const getOTPError = (payload) => ({
  type: GET_OTP_ERROR,
  payload,
});

// verify OTP actions
export const verifyOTP = (payload) => ({ type: VERIFY_OTP, payload });
export const verifyOTPLoading = () => ({ type: VERIFY_OTP_LOADING });
export const verifyOTPSuccess = (payload) => ({
  type: VERIFY_OTP_SUCCESS,
  payload,
});
export const verifyOTPError = (payload) => ({
  type: VERIFY_OTP_ERROR,
  payload,
});

// verify User
export const verifyUser = (payload) => ({ type: VERIFY_USER, payload });
export const verifyUserSuccess = (payload) => ({
  type: VERIFY_USER_SUCCESS,
  payload,
});
export const verifyUserError = (payload) => ({
  type: VERIFY_USER_ERROR,
  payload,
});

// GET CURRENT USER
export const getCurrentUser = () => ({ type: GET_CURRENT_USER });

// Logout User
export const logoutUser = () => ({ type: LOGOUT_USER });
export const logoutUserSuccess = (payload) => ({
  type: LOGOUT_USER_SUCCESS,
  payload,
});
export const logoutUserError = (payload) => ({
  type: LOGOUT_USER_ERROR,
  payload,
});
